// @ts-nocheck

import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  getAwaitingTracks,
  getCuratorStats,
  getMissedTracks,
  getReviewedTracks,
  skipReview,
} from 'Redux/actions/reviewsActions'
import { CampaignPlatformTypeEnum, ReviewStatus } from 'Types/index'
import { reviewRequestSeenEvent, reviewSkippedEvent } from 'Helpers/tagManager'
import InfinityScrollWrapper from 'Shared/components/InfinityScrollWrapper'
import { getUserId } from 'Redux/selectors/auth'
import {
  getAwaitingTracksSelector,
  getAwaitingTracksTotalSelector,
  getMissedTracksSelector,
  getReviewedTracksSelector,
  getTotalMissedTracksSelector,
  getTotalReviewedTracksSelector,
} from 'Redux/selectors/reviews'
import { Modal } from '../Modal'
import { ReviewTrack } from '../ReviewTrack'
import { ReviewSentSuccess } from '../ReviewSentSuccess'
import { SkipReview } from '../SkipReview'
import { TrackListItem } from '../TrackListItem'
import {
  Review,
  ReviewMobileProps,
  SkipMobileProps,
  Tabs,
  TrackListProps,
} from './props'
import {
  Container,
  EmptyListContainer,
  EmptyListPlaceholder,
  TabButtonCount,
  TabButtonTitle,
  TabPane,
  TabTitles,
} from './styles'

export const TrackList: FunctionComponent<TrackListProps> = ({
  setVisibleContent,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const userId = useSelector(getUserId)
  const awaitingCampaigns = useSelector(getAwaitingTracksSelector)
  const reviewedCampaigns = useSelector(getReviewedTracksSelector)
  const missedCampaigns = useSelector(getMissedTracksSelector)
  const totalAwaitingCampaigns = useSelector(getAwaitingTracksTotalSelector)
  const totalReviewedCampaigns = useSelector(getTotalReviewedTracksSelector)
  const totalMissedCampaigns = useSelector(getTotalMissedTracksSelector)

  const countPotentialReward = (data: number) => {
    const amount: string =
      awaitingCampaigns &&
      awaitingCampaigns.find(item => item.id === +data)?.potential_reward

    return amount
  }

  const awaitingCampaignsLenght = awaitingCampaigns?.length === 1

  const [modalHeaderGreen, setModalHeaderGreen] = useState<boolean>(true)
  const [awaitingPaginatorPage, setAwaitingPaginatorPage] = useState<number>(1)
  const [reviewedPaginatorPage, setReviewedPaginatorPage] = useState<number>(1)
  const [missedPaginatorPage, setMissedPaginatorPage] = useState<number>(1)

  const [isReviewModalVisible, setIsReviewModalVisible] = useState(false)
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false)
  const [skipReviewModalVisible, setSkipReviewModalVisible] = useState(false)

  const [skipModalData, setSkipModalData] = useState<SkipMobileProps | null>(
    null
  )
  const [
    reviewModalData,
    setReviewModalData,
  ] = useState<ReviewMobileProps | null>(null)

  const mobileHideContent = useMemo(
    () =>
      !!(
        window.innerWidth < 576 &&
        (isReviewModalVisible ||
          isSuccessModalVisible ||
          skipReviewModalVisible)
      ),
    [isReviewModalVisible, isSuccessModalVisible, skipReviewModalVisible]
  )

  useEffect(() => {
    dispatch(getAwaitingTracks(1))
    dispatch(getReviewedTracks(1))
    dispatch(getMissedTracks(1))
  }, [])

  const [currentTubKey, setCurrentTubKey] = useState<Tabs>(Tabs.awaiting_review)

  const getCurrentAwaitingTracks = () => {
    setAwaitingPaginatorPage(prevValue => {
      dispatch(getAwaitingTracks(prevValue + 1))
      return prevValue + 1
    })
  }

  const getCurrentReviewedTracks = () => {
    setReviewedPaginatorPage(prevValue => {
      dispatch(getReviewedTracks(prevValue + 1))
      return prevValue + 1
    })
  }

  const getCurrentMissedTracks = () => {
    setMissedPaginatorPage(prevValue => {
      dispatch(getMissedTracks(prevValue + 1))
      return prevValue + 1
    })
  }

  useEffect(() => {
    awaitingCampaignsLenght &&
      reviewRequestSeenEvent(
        awaitingCampaigns[0].id,
        awaitingCampaigns[0].campaign.id,
        CampaignPlatformTypeEnum.SPOTIFY,
        userId,
        false
      )
  }, [awaitingCampaigns, awaitingCampaignsLenght])

  const onActionCallback = () => {
    dispatch(getAwaitingTracks(awaitingPaginatorPage))
    dispatch(getReviewedTracks(reviewedPaginatorPage))
    dispatch(getMissedTracks(missedPaginatorPage))
    dispatch(getCuratorStats())
  }

  const openReviewModal = (props: ReviewMobileProps) => {
    setReviewModalData(props)
    setIsReviewModalVisible(true)
    setVisibleContent(false)
  }

  const closeReviewModal = () => {
    setReviewModalData(null)
    setVisibleContent(true)
    setIsReviewModalVisible(false)
  }

  const openSkipModal = (props: SkipMobileProps) => {
    setIsReviewModalVisible(false)
    setSkipModalData(props)
    setSkipReviewModalVisible(true)
    setVisibleContent(false)
  }

  const onSuccess = () => {
    setIsSuccessModalVisible(true)
  }

  const skipReviewModalToggle = () => {
    setSkipReviewModalVisible(!skipReviewModalVisible)
    setVisibleContent(true)
  }

  const handleSkipReview = () => {
    dispatch(
      // @ts-ignore
      skipReview(skipModalData.review_id, skipModalData.campaign_id, error => {
        if (!error) {
          onSuccess()
          const potentialRewardAmount: string = countPotentialReward(
            skipModalData.review_id
          )
          reviewSkippedEvent(
            skipModalData.campaign_id,
            skipModalData.review_id,
            CampaignPlatformTypeEnum.SPOTIFY,
            potentialRewardAmount,
            userId,
            false
          )
        }
        onActionCallback()
      })
    )
  }

  useEffect(() => {
    if (isSuccessModalVisible) {
      onActionCallback()
    }
  }, [isSuccessModalVisible])

  const onCloseSuccess = () => {
    setVisibleContent(true)
    setIsReviewModalVisible(false)
    setIsSuccessModalVisible(false)
    setSkipReviewModalVisible(false)
    setModalHeaderGreen(true)
  }

  const memoAwaitingCampaigns = useMemo(() => {
    if (awaitingCampaigns.length && currentTubKey === Tabs.awaiting_review) {
      return (
        <InfinityScrollWrapper
          dataLength={awaitingCampaigns.length}
          isLoading={false}
          next={getCurrentAwaitingTracks}
          hasMore={awaitingCampaigns.length < totalAwaitingCampaigns}
        >
          {awaitingCampaigns?.map(el => {
            if (el.campaign) {
              return (
                <TrackListItem
                  key={el.id}
                  review={el}
                  openReviewModal={openReviewModal}
                  openSkipModal={openSkipModal}
                  onActionCallback={onActionCallback}
                />
              )
            }
            return null
          })}
        </InfinityScrollWrapper>
      )
    }
    return (
      <EmptyListContainer>
        <EmptyListPlaceholder>
          {t('reviewsPage.emptyAwaitingList')}
        </EmptyListPlaceholder>
      </EmptyListContainer>
    )
  }, [
    awaitingCampaigns.length,
    awaitingCampaigns,
    currentTubKey,
    awaitingPaginatorPage,
  ])

  const memoReviewedCampaigns = useMemo(() => {
    if (reviewedCampaigns.length && currentTubKey === Tabs.reviewed) {
      return (
        <InfinityScrollWrapper
          dataLength={reviewedCampaigns.length}
          isLoading={false}
          next={getCurrentReviewedTracks}
          hasMore={reviewedCampaigns.length < totalReviewedCampaigns}
        >
          {reviewedCampaigns?.map(el => {
            if (el.campaign) {
              return (
                <TrackListItem
                  key={el.id}
                  review={el}
                  openReviewModal={openReviewModal}
                  openSkipModal={openSkipModal}
                  onActionCallback={onActionCallback}
                />
              )
            }
            return null
          })}
        </InfinityScrollWrapper>
      )
    }

    return (
      <EmptyListContainer>
        <EmptyListPlaceholder>
          {t('reviewsPage.emptyReviewedList')}
        </EmptyListPlaceholder>
      </EmptyListContainer>
    )
  }, [
    reviewedCampaigns,
    reviewedCampaigns.length,
    currentTubKey,
    reviewedPaginatorPage,
  ])

  const memoMissedCampaigns = useMemo(() => {
    if (missedCampaigns.length && currentTubKey === Tabs.missed) {
      return (
        <InfinityScrollWrapper
          isLoading={false}
          next={getCurrentMissedTracks}
          dataLength={missedCampaigns.length}
          hasMore={missedCampaigns.length < totalMissedCampaigns}
        >
          {missedCampaigns?.map(el => {
            if (el.campaign) {
              return (
                <TrackListItem
                  key={el.id}
                  review={el}
                  openReviewModal={openReviewModal}
                  openSkipModal={openSkipModal}
                  onActionCallback={onActionCallback}
                />
              )
            }
            return null
          })}
        </InfinityScrollWrapper>
      )
    }
    return (
      <EmptyListContainer>
        <EmptyListPlaceholder>
          {t('reviewsPage.emptyMissedList')}
        </EmptyListPlaceholder>
      </EmptyListContainer>
    )
  }, [
    missedCampaigns,
    missedCampaigns.length,
    currentTubKey,
    missedPaginatorPage,
  ])

  const renderTabCount = (title: string, count: number) => (
    <>
      <TabButtonTitle>{title}</TabButtonTitle>
      <TabButtonCount>{count}</TabButtonCount>
    </>
  )

  const modalTitleMemo = useMemo(() => {
    if (!modalHeaderGreen) {
      return t('reviewsPage.warning')
    }
    if (reviewModalData?.review_status === ReviewStatus.awaiting_review) {
      return t('reviewsPage.modalTitle')
    }
    return t('reviewsPage.modalDetailsTitle')
  }, [modalHeaderGreen, reviewModalData])

  const skipModalTitleMemo = useMemo(() => {
    if (window.innerWidth > 576) {
      return t('reviewsPage.modalTitle')
    }
    return t('reviewsPage.skipReview')
  }, [skipReviewModalVisible])

  return (
    <>
      {!mobileHideContent && (
        <Container>
          <TabTitles
            // @ts-ignore
            onChange={(e: Tabs) => setCurrentTubKey(e)}
          >
            <TabPane
              tab={renderTabCount('Awaiting review', totalAwaitingCampaigns)}
              key={Tabs.awaiting_review}
            >
              {memoAwaitingCampaigns}
            </TabPane>
            <TabPane
              tab={renderTabCount('Reviewed', totalReviewedCampaigns)}
              key={Tabs.reviewed}
            >
              {memoReviewedCampaigns}
            </TabPane>
            <TabPane
              tab={renderTabCount('Missed', totalMissedCampaigns)}
              key={Tabs.missed}
            >
              {memoMissedCampaigns}
            </TabPane>
          </TabTitles>
        </Container>
      )}
      {isReviewModalVisible && (
        <Modal
          title={modalTitleMemo}
          isModalVisible={isReviewModalVisible}
          modalHeaderGreen={modalHeaderGreen}
          closeModal={onCloseSuccess}
        >
          {!isSuccessModalVisible && reviewModalData && (
            <ReviewTrack
              track_id={reviewModalData.track_id}
              openSkipModal={openSkipModal}
              setModalHeaderGreen={setModalHeaderGreen}
              onSuccess={onSuccess}
              onClose={closeReviewModal}
            />
          )}
          {isSuccessModalVisible && (
            <ReviewSentSuccess onCloseSucccess={onCloseSuccess} />
          )}
        </Modal>
      )}
      {skipReviewModalVisible && (
        <Modal
          title={skipModalTitleMemo}
          isModalVisible={skipReviewModalVisible}
          modalHeaderGreen={modalHeaderGreen}
          closeModal={skipReviewModalToggle}
        >
          {!isSuccessModalVisible && (
            <SkipReview
              toggle={skipReviewModalToggle}
              handleSkipReview={handleSkipReview}
            />
          )}
          {isSuccessModalVisible && (
            <ReviewSentSuccess skipFlow onCloseSucccess={onCloseSuccess} />
          )}
        </Modal>
      )}
    </>
  )
}
